/**
 * A form's draft when the record it edits arrives again from the server while
 * the form is mounted (a refetch, a parent reload): the server's new record,
 * with every field the person changed kept as they left it.
 *
 * Resetting only the dirty baseline to the new record — and not the draft —
 * left the form «unsaved» with nothing changed whenever the record differed
 * in any field (an `updated_at`, a field another screen edited). Taking the
 * new record whole would throw away what is being typed. A field counts as
 * changed when the draft differs from the record the form had BEFORE.
 */
export function keepEdits<T extends object>(before: T, after: T, draft: T): T {
    const out = { ...after };
    for (const key of Object.keys(draft) as (keyof T)[]) {
        if (!Object.is(draft[key], before[key])) out[key] = draft[key];
    }
    return out;
}
